import { LayoutElementBasedCarousel } from "@faire/deprecated-retailer-visitor-shared/components/LayoutElementRenderer/LayoutElementBasedCarousel";
import { ProductTileClickImpressionProvider } from "@faire/deprecated-retailer-visitor-shared/hooks/ProductTileImpression/ProductTileClickImpressionProvider";
import { Surface } from "@faire/web-api--source/faire/logging/data/Surface";
import { ILayoutElement } from "@faire/web-api--source/indigofair/data/ILayoutElement";
import { ProductTileContainer } from "@faire/web-api--source/indigofair/data/ProductTileContainer";
import { ProductTileScreenContainer } from "@faire/web-api--source/indigofair/data/ProductTileScreenContainer";
import { Spacer } from "@faire/web/slate/spacing";
import { Typography } from "@faire/web/slate/Typography";
import React, { PropsWithChildren } from "react";

interface IProductTileImpressionProviderProps {
  onClickEventName: string | undefined;
  requestId: string | undefined;
}

const ProductTileImpressionProvider: React.FC<
  PropsWithChildren<IProductTileImpressionProviderProps>
> = ({ children, onClickEventName, requestId }) => {
  const context =
    `${ProductTileContainer.CATEGORY_PRODUCT_RESULTS_LAYOUT_ELEMENT_CAROUSEL}|${onClickEventName ?? ""}` as const;

  return (
    <ProductTileClickImpressionProvider
      context={context}
      requestId={requestId}
      productTileContainer={
        ProductTileContainer.CATEGORY_PRODUCT_RESULTS_LAYOUT_ELEMENT_CAROUSEL
      }
      containerName={onClickEventName}
      screenContext={Surface.CATEGORY_PRODUCT_RESULTS}
      containerContext={onClickEventName as ProductTileScreenContainer}
      contextToken=""
    >
      {children}
    </ProductTileClickImpressionProvider>
  );
};

export const LoggedOutCategoryPagePopularNearYouCarousel: React.FC<{
  layoutElement: ILayoutElement;
  requestId: string | undefined;
}> = ({ layoutElement, requestId }) => {
  return (
    <ProductTileImpressionProvider
      requestId={requestId}
      onClickEventName={layoutElement.on_click_event_name}
    >
      <Typography
        variant={{
          mobileAndAbove: "pageHeaderSerifRegular",
          xLargeAndAbove: "displaySSerifRegular",
        }}
        className="pl-4! md:pl-0!"
      >
        {layoutElement.main_text}
      </Typography>
      <Spacer size="3x" />
      <LayoutElementBasedCarousel
        layoutElement={layoutElement}
        requestId={requestId ?? ""}
        itemsPerSlide={{
          mobileAndAbove: 2,
          tabletAndAbove: 4,
          desktopAndAbove: 5,
          xLargeAndAbove: 6,
        }}
        hideTitle
        arrowOffsetX={0}
      />
    </ProductTileImpressionProvider>
  );
};
